export default {"src":"/_next/static/media/bank-visa.95f518a4.svg","height":24,"width":75,"blurWidth":0,"blurHeight":0};